import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ImageViewerService {
  private isVisibleSubject = new BehaviorSubject<boolean>(false);
  private imagesSubject = new BehaviorSubject<(string | any)[]>([]);
  private startIndexSubject = new BehaviorSubject<number>(0);

  get isVisible$(): Observable<boolean> {
    return this.isVisibleSubject.asObservable();
  }
  get images$(): Observable<(string | any)[]> {
    return this.imagesSubject.asObservable();
  }
  get startIndex$(): Observable<number> {
    return this.startIndexSubject.asObservable();
  }

  open(images: (string | any)[], startIndex: number = 0) {
    this.imagesSubject.next(images);
    this.startIndexSubject.next(startIndex);
    this.isVisibleSubject.next(true);
  }

  close() {
    this.isVisibleSubject.next(false);
  }
} 